import { SwipeableDrawer } from "@mui/material";
import { Link } from "react-router-dom";
import RoutesConst from "../../consts/RoutesConst";
import GeneralStrings from "../../strings/GeneralStrings";
import "./MobileNavDrawer.scss";
import { socialItems } from "./navbar-items.js";

const MobileNavDrawer = ({ isDrawerOpen, setIsDrawerOpen }) => {
  const NAVBAR_STRINGS = GeneralStrings.NAVBAR;

  return (
    <SwipeableDrawer
      anchor="left"
      className="mobile-nav-drawer"
      open={isDrawerOpen}
      onOpen={() => {}}
      onClose={() => setIsDrawerOpen(false)}
    >
      <div className="mobile-nav-link-container flex-col">
        <Link
          to={RoutesConst.DEFAULT}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.HOME}
        </Link>
        <Link
          to={RoutesConst.SERVICES}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.SERVICES}
        </Link>
        <Link
          to={RoutesConst.SERVICE_AREA}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.SERVICE_AREA}
        </Link>
        <Link
          to={RoutesConst.ENROLL}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.ENROLL}
        </Link>
        <Link
          to={RoutesConst.LIFEGUARDS}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.LIFEGUARDS}
        </Link>
        <Link
          to={RoutesConst.INSTRUCTORS}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.BECOME_AN_INSTRUCTOR}
        </Link>
        <Link
          to={RoutesConst.ABOUT_US}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.ABOUT_US}
        </Link>
        <Link
          to={RoutesConst.REVIEWS}
          className="nav-link"
          onClick={() => setIsDrawerOpen(false)}
        >
          {NAVBAR_STRINGS.REVIEWS}
        </Link>
        <hr className="social-divider" />
        <div className="mobile-nav-social-links-container flex">
          {socialItems}
        </div>
      </div>
    </SwipeableDrawer>
  );
};

export default MobileNavDrawer;
